import { jsx as c } from "react/jsx-runtime";
import a from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as l } from "react";
const m = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "9 7 14 18", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M23 23.313V10.938c0-.448-.184-.877-.513-1.194a1.78 1.78 0 0 0-1.237-.494h-2.917C18.333 8.007 17.29 7 16 7s-2.333 1.007-2.333 2.25H10.75c-.966 0-1.75.755-1.75 1.688v12.375C9 24.244 9.784 25 10.75 25h10.5c.966 0 1.75-.756 1.75-1.687M15.125 9.25c0-.466.392-.844.875-.844.48.006.869.38.875.844 0 .466-.392.844-.875.844s-.875-.378-.875-.844M12.2 14a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h7.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2zm-.2 3.2c0-.11.09-.2.2-.2h7.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2h-7.6a.2.2 0 0 1-.2-.2zm.2 2.8a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h7.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2z", clipRule: "evenodd" })), v = /* @__PURE__ */ l(({ size: e = "inherit", sx: o, ...i }, n) => {
  const r = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ c(a, {
    ...i,
    ref: n,
    component: m,
    inheritViewBox: !0,
    sx: r
  });
});
v.displayName = "svg_audit_log";
export {
  v as default
};
